<template>
  <div>
    <div class="countdown">
      <div class="_countdown">
        <div class="countdownDays countdownWrapper">
          <div class="_countdownDays countdownNumber">
            {{ countdownDays | two_digits }}
          </div>
          <div class="countdownLabel">Days</div>
        </div>
        <div class="countdownHours countdownWrapper">
          <div class="_countdownHours countdownNumber">
            {{ countdownHours | two_digits }}
          </div>
          <div class="countdownLabel">Hrs</div>
        </div>
        <div class="countdownMins countdownWrapper">
          <div class="_countdownMins countdownNumber">
            {{ countdownMins | two_digits }}
          </div>
          <div class="countdownLabel">Mins</div>
        </div>
        <div class="countdownSecs countdownWrapper">
          <div class="_countdownSecs countdownNumber">
            {{ countdownSecs | two_digits }}
          </div>
          <div class="countdownLabel">Secs</div>
        </div>
      </div>
    </div>
    <!-- <div id="countdownBarTimer" class="countdownBarTimer">
      <div class="countdownProgress" :style="{width: countdownProgress+'px' }"></div>
    </div> -->
    <!-- <div class="dayLeft">
      {{countdownDays}} Days Left!
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Countdown",
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      countdownProgress: 0,
      countdownDays: 0,
      countdownHours: 0,
      countdownMins: 0,
      countdownSecs: 0,
    };
  },
  methods: {
    countdownInit() {
      var timer;
      var now = new Date();
      var timeDiff = new Date(this.endDate).getTime() - now.getTime();
      var seconds = Math.floor(timeDiff / 1000);
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);
      var days = Math.floor(hours / 24);
      hours %= 24;
      minutes %= 60;
      seconds %= 60;
      if (days < 0) {
        days = hours = minutes = seconds = 0;
      }

      this.countdownDays = days;
      this.countdownHours = hours;
      this.countdownMins = minutes;
      this.countdownSecs = seconds;
      if (timeDiff <= 0) {
        clearTimeout(timer);
        return;
      }
      timer = setTimeout(this.countdownInit, 1000);

      // this.countdownAnimation(days, hours, minutes, seconds);
    },
    countdownAnimation(days, hours, minutes, seconds) {
      var initialOffsetSecs = 198.25 / 60;
      var initialOffsetMins = 198.25 / 60;
      var initialOffsetHrs = 198.25 / 24;
      var initialOffsetDays = 198.25 / 365;

      var daysPath = document.querySelector(".circleAnimation.days");
      var hrsPath = document.querySelector(".circleAnimation.hrs");
      var minsPath = document.querySelector(".circleAnimation.mins");
      var secsPath = document.querySelector(".circleAnimation.secs");

      daysPath.style.strokeDashoffset = (
        (365 - days) *
        initialOffsetDays
      ).toString();
      hrsPath.style.strokeDashoffset = (
        (60 - hours) *
        initialOffsetHrs
      ).toString();
      minsPath.style.strokeDashoffset = (
        (365 - minutes) *
        initialOffsetMins
      ).toString();
      secsPath.style.strokeDashoffset = (
        (60 - seconds) *
        initialOffsetSecs
      ).toString();
    },
  },
  filters: {
    two_digits(value) {
      if (value.toString().length <= 1) {
        return "0" + value.toString();
      }
      return value.toString();
    },
  },
  mounted() {
    this.countdownInit();
  },
};
</script>

<style lang="scss" scoped>
$countdownSize: 300px;

.countdown {
  display: block;
  text-align: center;
  margin-top: 15px;
  @media only screen and (max-width: $sm) {
    margin-top: 45px;
  }
  ._countdown {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
  }

  .countdownWrapper {
    position: relative;
    text-align: center;
    height: 100px;
    min-width: 100px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    @media only screen and (max-width: $sm) {
      height: 50px;
      min-width: 50px;
      /* margin-right: 50px; */
    }

    .countdownNumber {
      font-family: "Antique Olive";
      font-style: normal;
      font-weight: 700;
      font-size: 48px;
      line-height: 80%;
      color: #00285e;
    }

    .countdownLabel {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      color: #161e26;
      text-transform: uppercase;
    }
  }
}

.dayLeft {
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  line-height: 24px;
}
</style>
